import { gql } from '@apollo/client';

export const DAILY_COLLECTION_EXTRACT = () => {
    return gql`
        mutation Daily_collection_extract($type: String!, $from_date: String!, $to_date: String!, $report_type: String!, $user_name: String! ,$email_ids: [String!]!) {
            collection_distribution_extract(
                type: $type
                from_date: $from_date
                to_date: $to_date
                report_type: $report_type
                email_ids: $email_ids
                user_name: $user_name
            ) {
                message
                status
            }
        }
    `;
};

export const LEADS_QUERY = () => {
    return gql`query($page_size: Int, $source: String!, $page_num: Int, $dealer_id: Int, $user_id: Int, $status_id: [Int!], $loan_type_id: [Int!], $updated_by: [Int!], $search_text: String, $column: String, $value: String, $is_update_financier_list: String, $date_type: String, $from_date: DateTime, $to_date: DateTime, $status_id_exclude: [Int!]){
        lead_list(filter_params:{source:$source,page_size:$page_size,page_num:$page_num,dealer_id:$dealer_id,user_id:$user_id,status_id:$status_id,loan_type_id:$loan_type_id,updated_by:$updated_by,search_text:$search_text,order_by:{column:$column,value:$value},is_update_financier_list:$is_update_financier_list,date_type:$date_type,from_date:$from_date,to_date:$to_date, status_id_exclude:$status_id_exclude}){
            leads{
                id
                drawdown_id
                status_id
                step
                dealer_name
                dealer_id
                gcd_code
                priority
                make_year
                make_id
                make_name
                model_id
                model_name
                variant_id
                variant_name
                other_mmv
                plate_number
                car_type
                created_date
                lead_submitted_by
                submitted_by_role
                updated_date
                assign_to
                ops_verifier
                credit_appraisal
                credit_ops
                ops_user
                car_otr
                tax_amount
                loan_amount_offer
                loan_needed
                loan_amount
                is_orcr_verified
                title_box_status
                edit_loan_amount
                redrawdown_status
			          redrawdown_lead_id
                loan_type_text
                preferred_date
                on_behalf_name
                on_behalf_type
                or_document
                cr_document
                loan_status{
                    name
                    status_id
                }
                
                is_credit_appraisal
                is_show_withdraw
                is_show_submit
                credit_appraisal_requested_date
                credit_appraised_date
                mrp_data {
                  make_id
                  model_id
                  variant_id
                  make_year
                  mrp
                  listing_date
                  comments
                }
            
            }
            pagination{
                totalpage
                totalrecords
                prevpage
                nextpage
                page_size
            }
            tab_data{
                my_cases
                all_cases
            }      
      }
    }`;
}

export const LEADS_QUERY_INVENTORY = () => {
    return gql`query($page_size: Int, $source: String!, $page_num: Int, $dealer_id: Int,$status_id: [Int!],$search_text:String,$search_type:String,$area_id:Int,$agent_bm: [Int!],$so_sm: [Int!]){
        inventory_view(inventoryViewInput:{source:$source,page_size:$page_size,page_num:$page_num,dealer_id:$dealer_id,search_text:$search_text,search_type:$search_type,status_id:$status_id,area_id:$area_id,agent_bm:$agent_bm,so_sm:$so_sm}){
            leads{
                id
                drawdown_id
                dealer_id
                doc_status
                lead_source
                agent_id
                bro_id
                sfa_role_id
                ops_user
                credit_ops
                credit_appraisal
                ops_user
                resubmission_type
                bm_id
                step
                am_id
                zm_id
                rbh_id
                aro_id
                arco_id
                vp_id
                assign_to
                created_date
                updated_date
                submitted_date
                last_modified_date
                final_submission
                dealer_name
                gcd_code
                make_name
                make_year
                model_name
                variant_name
                plate_number
                text_color
                loan_amount
                due_amount
                front_image_url
                lead_status
                due_date
                principal_amount
                interestAmount
                area_name
                agent_name
                bro_name
                bm_name
                am_name
                zm_name
                so_id
                so_name
                sm_id
                sm_name
                nh_id
                nh_name
                th_id
                th_name
                lead_details{
                bpkp_number
            }
            lead_disbursement{
                principal_amount
                remaining_principal_amount
                disbursement_date
                last_repyament_date
            }
            lead_payment_history{
                lead_id
                comment
                document_proof
                history_type
                user_id
                name
                status
                created_date
            }
        }
        area{
            id
            name
            value
          }
          dealer_details{
            available_limit
            used_limit
            per_car_limit
            drawing_power
          }
          dealer_data{
            id
            dealership_email
            gcd_code
            organization
          }
          loan_due_overdue{
            duein7days
            carbetween7to30
            carin7days
            duebetween7to30
            overdue
            total_due
          }
          pagination{
            totalpage
            totalrecords
            prevpage 
            nextpage
            page_size
          }
          sfaUsers{
            id
            name
            
          }     
      }
    }`;
}

export const SAVE_LOAN_DICTIONARY = () => {
  return gql`
    mutation save_loan_dictionary($saveLoanInput:[LoanDictionaryInput!]!){
      save_loan_dictionary(saveLoanInput:$saveLoanInput){
          message
      }
    }
  `;
}

export const LEADS_QUERY_INVENTORY_DETAILS=()=>{
  return gql`query($lead_id: Int!, $lead_source: LEAD_SOURCE_TYPE!){
    inventory_view_detail(lead_id:$lead_id,lead_source:$lead_source){
      id
      drawdown_id
      dealer_id
      status_id
      plate_number
      dealer_name
      bro_name
      bm_name
      agent_name
      am_name
      zm_name
      priority
      step
      make_name
      model_name
      variant_name
      make_year
      tax_amount
      interestAmount
      penaltyAmount
      due_date
      due_amount
      principal_amount
      edit_loan_amount
      loan_amount
      loan_needed
      loan_amount_offer
      lead_status
      financier_reference_id
      financier_settlement_date
      financier_lender
      loan_status{
        name
      }
      lead_payment_history{
        lead_id
        comment
        document_proof
        history_type
        name
        created_date
      }
      dealer_upload_proof {
        is_same_calculator
        dealer_content
        doc_proof
        notes
        created_date
      }
      lead_disbursement{
        disbursement_amount
        principal_amount
        remaining_principal_amount
        disbursement_date
        last_repyament_date
        pncm_date
        financier_booking_date
      }
      lead_details{
        bpkp_number
        engine_number
      }
      lead_quote{
        interest_fee
        admin_fee_type
        admin_fee
        vat_percentage
        disbursement_amount
        edit_loan_amount
        loan_needed
        loan_amount_offer
        interest_fee
        renewal_fee_type
        renewal_fee
        provision_fee
        loan_tenure
        dst_percentage
        renewal_penalty
        penalty_fee
        penalty_interest
      }
        repayment_transactions{
        id
        lead_id
        repayment_amount
        interest_amount
        penalty_amount
        renewal_amount
        principal_amount
        interest_cashback
        total_with_cashback
        is_cashback
        is_final_repayment
        waiver
        repayment_date
        financier_cutoff_date
        mode
        user_id
        created_date
      }
    }
  }`
}


export const SAVE_LOAN_HISTORY = () => {
  return gql`
    mutation save_loan_payment_history($savePaymentHistoryInput:SavePaymentHistoryInput!){
      save_loan_payment_history(savePaymentHistoryInput:$savePaymentHistoryInput){
          message
      }
    }
  `;
}


export const SAVE_LOAN_REPAYMENT_TRANSACTION=()=>{
  return gql`
    mutation save_loan_repayment_transactions($saveTransactionInput:SaveTransactionInput!){
      save_loan_repayment_transactions(saveTransactionInput:$saveTransactionInput){
          message
      }
    }
  `;
}

export const CLOSE_LOAN=()=>{
  return gql`
    mutation close_loan($closeLoanLoanInput:CloseLoanInput!){
      close_loan(closeLoanLoanInput:$closeLoanLoanInput){
          message
      }
    }
  `;
}

export const DISBURSE_LOAN=()=>{
  return gql`
    mutation disburse_loan($disburseLoanInput:DisburseLoanInput!){
      disburse_loan(disburseLoanInput:$disburseLoanInput){
          message
      }
    }
  `;
}

export const LEAD_DETAIL_QUERY=(lead_id)=>{
  return gql`
  query{
    lead_detail(lead_id:${lead_id},lead_source : "web"){
      lead_id
      dealer_id
      status_id
      lead_source
      doc_status
      sfa_role_id
      gcloud_user_id
      so_id
      so_name
      submitted_date
      updated_date
      updated_by
      financier_id
      financier_name
      dealer_type
      financier_reference_id
      financier_lender
      step
      ops_verifier
      credit_appraisal
      credit_ops
      ops_user
      resubmission_type
      priority
      created_date
      edit_loan_amount
      remarks
      car_otr
      ltv_per
      disbursement_amount
      chassis_number
      fuel_type
      transmission_type
      piston_displacement
      inspection_comment
      odometer
      is_orcr_verified
      credit_fmv_value
      redrawdown_status
		  redrawdown_lead_id
      drawdown_id
      redrawdown_disbursement_amount
      redrawdown_disbursement_date
      pncm_date
      disbursement_date
      powercred_vehicle_information {
        or_number
        cr_number
        file_number
        body_type
      }
      lead_quote{
        per_car_limit
        available_limit
        disbursement_amount
        car_otr
        ltv_per
        loan_amount_offer
        loan_needed
        tax_validity
        tax_amount
        remarks
        drawing_power
        sanction_limit
        used_limit
        interest_fee
        provision_fee
        dst_percentage
        admin_fee_type
        admin_fee
        renewal_fee_type
        renewal_fee
        renewal_time
        loan_tenure
        vat_percentage
        edit_loan_amount
        penalty_fee
        penalty_interest
        renewal_penalty
        min_fmv_range
        max_fmv_range
        avg_fmv_range
      }
      lead_inspection{
        attributes_id
        value
        text_value
      }
      lead_inspection_docs
      deductions
      redrawdown_disbursement_days
      active_dealer_grade
      area_id
      make_id
      model_id
      variant_id
      other_mmv
      plate_number
      make_year
      car_type
      insurance_type
      purchase_date
      engine_number
      submitted_by
      dealer_id
      dealer_name
      dealership_email
      dealership_contact
      dealership_address
      dealer_bank_acc_name
      dealer_bank_acc_number
      last_updated_by
      last_thirty_days
      make
      model
      variant
      ltv_percentage_text
      tax_validity
      no_pol_location
      bpkp_status
      bpkp_remarks
      cancellation_text
      cancellation_id
      lead_docs{
        id
        doc_path
        doc_id
        parent_doc_id
        doc_path_watermark
        latitude
        longitude
        description
        doc_verification
        hardcopy_doc_verification
        doc_master{
          id
          parent_id
          doc_master_lang{
            name
          }
        }
      }
      title_box_comment
      title_box_status
      lead_title_box_docs{
        doc_path
        doc_path_watermark
        doc_name
        doc_id
        id
      }
      loan_type_text  
      loan_agreement_details
    }
  }
`
};

export const LEAD_TIMELINE=()=>{
  return gql`
  query($lead_id:Int!){ 
      lead_timeline(lead_id:$lead_id){
        id
        dealer_id
        lead_history{
        status_id
        user_id
        updated_by_source
        created_date
        user{
          name
        }
        loan_status{
          status_id
          name
        }
      }
      }
    }
  `;
};


export const ASSIGN_LEAD=()=>{
  return gql`
    mutation assign_lead($assignLeadInput:AssignLeadInput!){
      assign_lead(assignLeadInput:$assignLeadInput){
          message
      }
    }
  `;
}
export const REJECT_LEAD=()=>{
  return gql`mutation reject_lead($rejectLeadInput:RejectLeadInput!){
    reject_lead(rejectLeadInput:$rejectLeadInput){
        message
    }
  }
`
};

export const APPROVE_DOC=()=>{
  return gql`mutation approve_lead_doc($docApprovedInput:DocApprovedInput!){
    approve_lead_doc(docApprovedInput:$docApprovedInput){
        message
    }
  }
`
};

export const DELETE_DOC=()=>{
  return gql`mutation delete_doc($deleteDocInput:DeleteDocInput!){
    delete_doc(deleteDocInput:$deleteDocInput){
        status
        message
    }
  }
`
};

export const SAVE_DOC=()=>{
  return gql`mutation save_lead_doc($saveLeadDocInput:SaveLeadDocInput!){
    save_lead_doc(saveLeadDocInput:$saveLeadDocInput){
        message
    }
  }
`
};

export const GET_DOC_HISTORY=()=>{
  return gql`mutation get_document_history($docHistoryInput:DocHistoryInput!){
    get_document_history(docHistoryInput:$docHistoryInput){
      doc_history{
        id
        comment
        user_id
        source
        created_date
        lead_docs{
          id
          doc_id
          doc_master{
            id
            parent_id
            is_required
            is_required_app
            max_upload
            min_upload
            show_in_app
            sort_number
            doc_icon_url
            doc_sample_icon
            bg_color_color
            status
            doc_master_lang{
              name
            }
          }
        }
        user_details{
          name
        }
      }
    }
  }
`
};

export const RESUBMISSION=()=>{
  return gql`mutation resubmission($resubmissionInput:ResubmissionInput!){
    resubmission(resubmissionInput:$resubmissionInput){
        message
    }
  }
`
};

export const RESUBMISSION_CAR_VAL=()=>{
  return gql`mutation resubmission_car_valuation($resubmissionInput:ResubmissionCarValInput!){
    resubmission_car_valuation(resubmissionInput:$resubmissionInput){
        message
    }
  }
`
};

export const UPDATE_INFO=()=>{
  return gql`mutation update_information($updateInformationInput:UpdateInformationInput!){
    update_information(updateInformationInput:$updateInformationInput){
        message
    }
  }
`
};

export const GET_CAR_QUOTE=()=>{
  return gql`mutation get_car_quote($carQuoteInput:GetCarQuoteInput!){
    get_car_quote(carQuoteInput:$carQuoteInput){
      financier_mrp_data{
        region
        area_id
        make
        make_id
        model
        model_id
        variant
        variant_id
        make_year
        dealer_id
        is_pd
        tax_amount
        tax_validity
        car_type
        financier_logo
      }
      car_otr
      loan_amount_offer
      ltv_per
      ltv_percentage_text
      per_car_limit
      available_limit
      disbursement_amount
      min_fmv_range
      avg_fmv_range
      max_fmv_range
      other_fields
    }
  }
`
};

export const UPDATE_CAR_VALUATION=()=>{
  return gql`mutation update_car_valuation($updateCarValuationInput:UpdateCarValuationInput!){
    update_car_valuation(updateCarValuationInput:$updateCarValuationInput){
        message
    }
  }
`
};

export const DISBURSAL_CREDIT_OPS=()=>{
  return gql`mutation disbursal_credit_ops($disbursalCreditOpsInput:DisbursalCreditOpsInput!){
    disbursal_credit_ops(disbursalCreditOpsInput:$disbursalCreditOpsInput){
        message
    }
  }
`
};


export const DEALER_NOTIFICATION_LIST=()=>{
  return gql`
  query($lead_source:LEAD_SOURCE_TYPE,$page_num:Int){ 
    notification_list(lead_source:$lead_source,page_num:$page_num){
        notifications{
          lead_id
          content
          created_date
          dealer_name
          gcd_code
        }
        pagination{
          totalpage
          totalrecords
          prevpage
          nextpage
          page_size
        }
      }
    }
  `;
};

export const SEND_NOTIFICATION=()=>{
  return gql`query($lead_id: Int!){
    send_payment_due_notification(lead_id:$lead_id){
      message
  }
}`
}

export const EXPORT_INVENTORY_REPORT=()=>{
  return gql`query($exportInventoryInput:InventoryViewInput!) {
    export_inventory_view(exportInventoryInput:$exportInventoryInput) {
      report_data
    }
  }`
}

export const GET_MMV_ALL = () => {
  return gql `query($make_year: Int!) {
    get_mmv_all(make_year: $make_year) {
      make {
        id
        name
      }
      model {
        id
        make_id
        name
      }
      variant {
        id
        make_id
        model_id
        name
      }
      mrp {
        id
        make_year
        make_id
        model_id
        variant_id
        mrp
      }
    }
  }`
}

export const UPDATE_CAR_INSPECTION=()=>{
  return gql`mutation($carInspectionInput:CarInspectionInput!){
    update_car_inspection(
      carInspectionInput:$carInspectionInput){
        message
      }
    }
`
};


export const GET_USER_LIST=()=>{
  
  return gql`query($role_id: Int!,$checker_role_id: Int!, $is_redis_force_update: Boolean!){
    get_user_list(role_id:$role_id,checker_role_id:$checker_role_id,is_redis_force_update: $is_redis_force_update) {
      user_id
      role_assigned_ids
      name
    }
  }`
}

export const EXPORT_FINANCE_REPORT=()=>{
  return gql`query($exportFinanceReportInput:ExportFinanceReportInput!) {
    export_finance_report(exportFinanceReportInput:$exportFinanceReportInput) {
      report_data
    }
  }`
}

export const GET_CALCULATOR_DATA=()=>{
  return gql`query($lead_id: Int!, $lead_source: String!,$type: String!,$calculator_date:String!,$repayment_percent:Float!){
    calculator_data(Calculatorinput:{lead_id:$lead_id,lead_source:$lead_source,type: $type,calculator_date:$calculator_date,repayment_percent:$repayment_percent}){
      total_payment_due
      principal_amount
      penaltyAmount
      interest
      renewal_fee
      renewal_payment_amount
      total_payment_due_renew
      interest_cashback_amount
      daysDisb
      grace_days
    }
  }`
}

export const GET_CREDIT_FMV = () => gql`
   query getCreditFMV(
    $make_id: Int!
    $model_id: Int!
    $variant_id: Int!
    $make_year: Int!
  ) {
    getCreditFMV(
      make_id: $make_id
      model_id: $model_id
      variant_id: $variant_id
      make_year: $make_year
    ){
      id
      lead_id
      date
      make_id
      make
      model_id
      model
      variant_id
      variant
      make_year
      credit_fmv_value
      status
      created_at
      updated_at
    }
  }
`;

export const UPDATE_DC_OVERRIDE=()=>{
  return gql`mutation dc_data_override($dcOverrideInput:DCOverrideInput!){
    dc_data_override(dcOverrideInput:$dcOverrideInput){
        message
    }
  }
`
};

export const GET_FINANCIER_LIST=()=>{
  return gql`query{
    get_financier_list{
      financier_id
      financier_name
    }
  }`
}

export const SAVE_CUT_OFF_DATE = () => {
  return gql`
    mutation update_cutoff_date($cutOffInput:[CutOffInput!]!){
      update_cutoff_date(cutOffInput:$cutOffInput){
        message
      }
    }
  `;
}

export const SAVE_BOOKING_DATE = () => {
  return gql`
    mutation update_booking_date($lead_id:Int!,$booking_date: String!){
      update_booking_date(lead_id:$lead_id,booking_date:$booking_date){
        message
      }
    }
  `;
}

export const GENERATE_LOAN_AGREEMENT = () => {
  return gql`
    mutation generate_loan_agreement($input: GenerateLoanAgreementInput!){
      generate_loan_agreement(input: $input)
    }
  `;
};

export const GET_LOAN_AGREEMENT_DETAILS = (lead_id) => {
  return gql`
    query {
      get_loan_agreement_details(lead_id: ${lead_id})
    }
  `;
};

export const UPDATE_ORCR_VERIFICATION = () => {
  return gql`
    mutation update_orcr_verification_requirment($input: UpdateOrcrVerificationInput!) {
      update_orcr_verification_requirment(input: $input) {
        message
        status
      }
    }
  `;
};

export const UPDATE_CAR_PRICING=()=>{
  return gql`mutation update_car_pricing($updateCarPricingInput:UpdateCarPricingInput!){
    update_car_pricing(updateCarPricingInput:$updateCarPricingInput){
        message
    }
  }
`
};

export const SEND_FOR_ESIGN = () => {
  return gql`
    mutation send_for_esign($input: SendForEsignInput!) {
      send_for_esign(input: $input)
    }
  `;
};

export const GET_ESIGN_DETAILS = (lead_id) => {
  return gql`
    query {
      get_esign_details(lead_id: ${lead_id})
    }
  `;
};

export const RESEND_ESIGN = () => {
  return gql`
    mutation resend_esign($input: ResendEsignInput!) {
      resend_esign(input: $input)
    }
  `;
};

export const APPROVE_ESIGN = () => {
  return gql`
    mutation approve_esign($input: ApproveEsignInput!) {
      approve_esign(input: $input)
    }
  `;
};

export const GET_SIGNING_DOCUMENT = (sign_token) => {
  return gql`
    query {
      get_signing_document(sign_token: "${sign_token}")
    }
  `;
};

export const PREVIEW_SIGNED_DOCUMENT = (sign_token, signature_url) => {
  return gql`
    query {
      preview_signed_document(sign_token: "${sign_token}", signature_url: "${signature_url}")
    }
  `;
};

export const UPDATE_SIGNER_STATUS = () => {
  return gql`
    mutation update_signer_status($input: UpdateSignerStatusInput!) {
      update_signer_status(input: $input)
    }
  `;
};


export const UPDATE_CREDIT_APPRAISAL_APPRAISED = gql`
  mutation UpdateCreditAppraisalValuation(
    $updateCreditAppraisalValuationInput: UpdateCreditAppraisalValuationInput!
  ) {
    update_credit_appraisal_valuation(
      updateCreditAppraisalValuationInput: $updateCreditAppraisalValuationInput
    ) {
      message
      lead_id
    }
  }
`;
export const REVERT_LOAN_AGREEMENT = () => {
  return gql`
    mutation revert_loan_agreement($input: RevertLoanAgreementInput!) {
      revert_loan_agreement(input: $input)
    }
  `;
};
